import { takeEvery } from 'redux-saga/effects';
import { actionPayload } from './actions';
import { useSetLocale as useLocale } from "react-admin"
import dayjs from "dayjs"
require("dayjs/locale/es")

export default function* saveToLocalStorage() {
    yield takeEvery('CHANGE_THEME', function* (action: actionPayload) {
        yield localStorage.setItem("theme", action.payload)
    })
}


export const useSetLocale = () => {
    const setLocale = useLocale()

    return async (locale: string) => {
        await setLocale(locale)
        // require('dayjs/locale/' + locale)
        dayjs.locale(locale)

        localStorage.setItem("locale", locale)

    }
}